import axios from '../utils/axios';

// Get all contact messages
export const getContacts = async (params = {}) => {
    const response = await axios.get('/contacts', { params });
    return response.data;
};

// Get single contact message
export const getContact = async (id) => {
    const response = await axios.get(`/contacts/${id}`);
    return response.data;
};

// Mark a contact message as read
export const markContactRead = async (id) => {
    const response = await axios.patch(`/contacts/${id}/read`);
    return response.data;
};

// Soft delete a contact message
export const deleteContact = async (id) => {
    const response = await axios.delete(`/contacts/${id}`);
    return response.data;
};

// Restore a contact message
export const restoreContact = async (id) => {
    const response = await axios.patch(`/contacts/${id}/restore`);
    return response.data;
};

// Permanently delete a contact message
export const forceDeleteContact = async (id) => {
    const response = await axios.delete(`/contacts/${id}/force-delete`);
    return response.data;
};

// Mass soft delete contacts
export const massDestroyContacts = async (data) => {
    const response = await axios.delete('/contacts/mass-destroy', { data });
    return response.data;
};

// Mass restore contacts
export const massRestoreContacts = async (data) => {
    const response = await axios.post('/contacts/mass-restore', data);
    return response.data;
};

// Mass permanently delete contacts
export const massForceDeleteContacts = async (data) => {
    const response = await axios.delete('/contacts/mass-force-delete', { data });
    return response.data;
};